import React from 'react'
import type { SecurityDevice } from '../../api/security'

export default function SecurityDevicesCard({
  devices,
  onRemove,
  removingId,
}: {
  devices: SecurityDevice[] | null | undefined
  onRemove: (device: SecurityDevice) => void
  removingId?: number | null
}) {
  return (
    <div className="rounded-xl border border-white/10 bg-white/5 p-4">
      <div className="font-semibold">Signed-in devices</div>
      <div className="text-sm text-white/70 mb-3">These devices can receive notifications and stay signed in. Remove any you don’t recognize.</div>
      {!devices || devices.length === 0 ? (
        <div className="text-sm text-white/70">No devices are registered right now.</div>
      ) : (
        <ul className="divide-y divide-white/10">
          {devices.map((d) => (
            <li key={d.id} className="flex items-center justify-between gap-4 py-3">
              <div className="min-w-0">
                <div className="text-white font-medium truncate">{d.device_label}</div>
                <div className="text-xs text-white/60 mt-0.5 truncate">Last seen {formatDate(d.last_seen_at)} • Token ••••{d.token_suffix || '????'}</div>
              </div>
              <button
                onClick={() => onRemove(d)}
                disabled={removingId === d.id}
                className="px-3 py-1.5 rounded-full border border-white/30 text-white/90 font-semibold hover:bg-white/5 disabled:opacity-50"
              >
                Remove
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

function formatDate(ts?: string | null) {
  if (!ts) return 'Unknown'
  try {
    return new Date(ts).toLocaleString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })
  } catch {
    return String(ts)
  }
}

